"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var polished_1 = require("polished");

var utils_1 = require("../utils");

var SwitchSlider = styled_components_1.default.span(function (_a) {
  var checked = _a.checked,
      sliderSize = _a.sliderSize,
      trackInset = _a.trackInset,
      colorOn = _a.colorOn,
      colorOff = _a.colorOff,
      shadow = _a.shadow;
  return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-radius: ", "px;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      height: ", "px;\n      width: ", "px;\n      background-color: ", ";\n      box-shadow: ", ";\n      transition: all 0.3s cubic-bezier(0.125, 0.85, 0.3, 1.125);\n      ", ";\n    "], ["\n      border-radius: ", "px;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      height: ", "px;\n      width: ", "px;\n      background-color: ", ";\n      box-shadow: ", ";\n      transition: all 0.3s cubic-bezier(0.125, 0.85, 0.3, 1.125);\n      ", ";\n    "])), sliderSize * 2, sliderSize - trackInset * 2, sliderSize - trackInset * 2, checked ? colorOn : colorOff, shadow, checked && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          transform: translateX(", "px);\n        "], ["\n          transform: translateX(", "px);\n        "])), sliderSize));
});
var SwitchTrack = styled_components_1.default.label(function (_a) {
  var theme = _a.theme,
      sliderSize = _a.sliderSize,
      trackInset = _a.trackInset,
      checked = _a.checked,
      trackColorOff = _a.trackColorOff,
      trackColorOn = _a.trackColorOn,
      disabled = _a.disabled;
  return styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      position: relative;\n      display: inline-block;\n      cursor: ", ";\n      width: ", "px;\n      height: ", "px;\n      border-radius: ", "px;\n      transition: background-color 0.2s, border-color 0.2s;\n      z-index: 1;\n      background: ", ";\n      border: ", "px solid ", ";\n      ", ";\n      ", ";\n      &:active {\n        ", " {\n          -webkit-transform: translateX(\n            ", "px\n          );\n          transform: translateX(", "px);\n          width: ", "px;\n        }\n      }\n    "], ["\n      position: relative;\n      display: inline-block;\n      cursor: ", ";\n      width: ", "px;\n      height: ", "px;\n      border-radius: ", "px;\n      transition: background-color 0.2s, border-color 0.2s;\n      z-index: 1;\n      background: ", ";\n      border: ", "px solid ", ";\n      ", ";\n      ", ";\n      &:active {\n        ", " {\n          -webkit-transform: translateX(\n            ", "px\n          );\n          transform: translateX(", "px);\n          width: ", "px;\n        }\n      }\n    "])), disabled ? 'not-allowed' : 'pointer', sliderSize * 2, sliderSize, sliderSize, trackColorOff, trackInset, polished_1.darken(0.05, trackColorOff), checked && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          background: ", ";\n          border: ", "px solid ", ";\n        "], ["\n          background: ", ";\n          border: ", "px solid ", ";\n        "])), trackColorOn, trackInset, polished_1.darken(0.05, trackColorOn)), disabled && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          background: ", ";\n          border: ", "px solid\n            ", ";\n        "], ["\n          background: ", ";\n          border: ", "px solid\n            ", ";\n        "])), theme.colors.disabledColor, trackInset, polished_1.darken(0.05, theme.colors.disabledColor)), SwitchSlider, checked ? sliderSize - trackInset * 3 : 0, checked ? sliderSize - trackInset * 3 : 0, sliderSize + trackInset);
});
var SwitchCheckbox = styled_components_1.default.input(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  left: 1px;\n  white-space: nowrap;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  left: 1px;\n  white-space: nowrap;\n"])));

function Switch(_a) {
  var name = _a.name,
      _b = _a.id,
      id = _b === void 0 ? null : _b,
      _c = _a.checked,
      checked = _c === void 0 ? false : _c,
      _d = _a.disabled,
      disabled = _d === void 0 ? false : _d,
      trackColorOn = _a.trackColorOn,
      trackColorOff = _a.trackColorOff,
      colorOn = _a.colorOn,
      colorOff = _a.colorOff,
      _e = _a.sliderSize,
      sliderSize = _e === void 0 ? 24 : _e,
      _f = _a.trackInset,
      trackInset = _f === void 0 ? 3 : _f,
      onChange = _a.onChange,
      variant = _a.variant,
      size = _a.size;
  var theme = styled_components_1.useTheme();
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Switch', variant, size);
  var sharedProps = {
    checked: checked,
    disabled: disabled,
    name: name,
    sliderSize: sliderSize,
    trackInset: trackInset,
    trackColorOn: utils_1.getColor(theme, themeStyles, 'trackColorOn', trackColorOn),
    trackColorOff: utils_1.getColor(theme, themeStyles, 'trackColorOff', trackColorOff),
    colorOn: utils_1.getColor(theme, themeStyles, 'colorOn', colorOn),
    colorOff: utils_1.getColor(theme, themeStyles, 'colorOff', colorOff)
  };
  return React.createElement(SwitchTrack, __assign({}, sharedProps), React.createElement(SwitchCheckbox, {
    id: id || name,
    name: name,
    type: 'checkbox',
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }), React.createElement(SwitchSlider, __assign({}, sharedProps)));
}

exports.Switch = Switch;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;